import React, { useState } from "react";
import { X } from "lucide-react";
import PostJobPage from "../../modules/client/components/PostaJob";

interface EditJobModalProps {
  job: any;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const EditJobModal: React.FC<EditJobModalProps> = ({ job, isOpen, onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  console.log("job", job);



  if (!isOpen || !job) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b sticky top-0 bg-white">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-semibold">Edit Job #{job.id}</h2>
              <p className="text-sm text-gray-500 mt-1">Update job information and details</p>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full" disabled={isLoading}>
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="space-y-6 mb-6 px-6">
          <PostJobPage
            jobType={job.isLocal ? "local" : "international"}
            showSidebar={false}
            editJobId={{ jobId: job.id }}
            onJobUpdated={onSuccess}
          />
        </div>

        {/* Footer Actions */}
        {/* <div className="p-6 border-t bg-gray-50 flex justify-end gap-3">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={isLoading} className="flex items-center gap-2">
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Updating...
              </>
            ) : (
              <>
                <Save className="h-4 w-4" />
                Update Job
              </>
            )}
          </Button>
        </div> */}
      </div>
    </div>
  );
};

export default EditJobModal;
